import React from 'react';
import AboutComponent from '../components/about/AboutComponent';

export default function About() {
  return (
    <div>
      <AboutComponent />
    </div>
  )
}
